export const MONTHS_SHORT = ["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"];
export const MONTHS_FULL  = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];

export const NAV = [
  { id:"dashboard", icon:"🏠", label:"Home" },
  { id:"dompet",    icon:"👛", label:"Dompet" },
  { id:"transaksi", icon:"💳", label:"Transaksi" },
  { id:"anggaran",  icon:"🎯", label:"Anggaran" },
  { id:"investasi", icon:"📈", label:"Investasi" },
  { id:"milestone", icon:"🚩", label:"Milestone" },
  { id:"laporan",   icon:"📊", label:"Laporan" },
  { id:"kategori",  icon:"🏷️", label:"Kategori" },
  { id:"backup",    icon:"💾", label:"Backup" },
];

export const PAGE_TITLE = {
  dashboard:"Dashboard", dompet:"Dompet & Rekening", transaksi:"Transaksi",
  anggaran:"Anggaran", investasi:"Portofolio", milestone:"Milestone", laporan:"Laporan",
  kategori:"Kategori", backup:"Backup & Restore",
};

export const INIT_CATS = [
  { id:"c01", name:"Gaji",                type:"income",    color:"#22C55E", icon:"💰" },
  { id:"c02", name:"Uang Dadakan",         type:"income",    color:"#F59E0B", icon:"💵" },
  { id:"c03", name:"Dividen / Investasi",  type:"income",    color:"#3B82F6", icon:"📈" },
  { id:"c04", name:"Pemasukan Lainnya",    type:"income",    color:"#A78BFA", icon:"➕" },
  { id:"c05", name:"Pengeluaran Fixed",    type:"expense",   color:"#EF4444", icon:"🏠" },
  { id:"c06", name:"Dana Darurat",         type:"expense",   color:"#0EA5E9", icon:"🛡️" },
  { id:"c07", name:"BTC",                  type:"expense",   color:"#F7931A", icon:"₿"  },
  { id:"c08", name:"FIRE",                 type:"expense",   color:"#F43F5E", icon:"🔥" },
  { id:"c09", name:"Dana Flex",            type:"expense",   color:"#8B5CF6", icon:"💳" },
  { id:"c10", name:"Micro Emergency",      type:"expense",   color:"#F97316", icon:"🚨" },
  { id:"c11", name:"Makan & Minum",        type:"expense",   color:"#10B981", icon:"🍜" },
  { id:"c12", name:"Transportasi",         type:"expense",   color:"#6B7280", icon:"🚗" },
  { id:"c13", name:"Hiburan",              type:"expense",   color:"#EC4899", icon:"🎮" },
  { id:"c14", name:"Kesehatan",            type:"expense",   color:"#06B6D4", icon:"💊" },
  { id:"c15", name:"Belanja",              type:"expense",   color:"#FB923C", icon:"🛒" },
  { id:"c16", name:"Pengeluaran Lainnya",  type:"expense",   color:"#78716C", icon:"📤" },
  { id:"c17", name:"Saham",                type:"investasi", color:"#22C55E", icon:"📈" },
  { id:"c18", name:"Crypto",               type:"investasi", color:"#F7931A", icon:"₿"  },
  { id:"c19", name:"Reksa Dana",           type:"investasi", color:"#8B5CF6", icon:"📄" },
  { id:"c20", name:"Emas",                 type:"investasi", color:"#E8A21C", icon:"🥇" },
  { id:"c21", name:"Investasi Lainnya",    type:"investasi", color:"#06B6D4", icon:"💎" },
];

export const INIT_INV = [];

export const WALLET_COLORS = ["#0070BB","#E8A21C","#22C55E","#EF4444","#8B5CF6","#06B6D4","#F97316","#EC4899","#6B7280","#10B981"];
export const WALLET_ICONS  = ["🏦","💳","💰","🏧","📱","💵","🏠","🔒","💎","⚡"];

export const TYPE_META = {
  saham_idx: { label:"Saham IDX", color:"#22C55E", icon:"🇮🇩", desc:"Bursa IDX (lot)" },
  saham_us:  { label:"Saham US",  color:"#3B82F6", icon:"🇺🇸", desc:"NYSE/NASDAQ (unit)" },
  crypto:    { label:"Crypto",    color:"#F7931A", icon:"₿",   desc:"Aset digital (unit)" },
  rdpu:      { label:"RDPU",      color:"#06B6D4", icon:"💵",  desc:"Reksa Dana Pasar Uang" },
  rdpt:      { label:"RDPT",      color:"#8B5CF6", icon:"📄",  desc:"Reksa Dana Pendapatan Tetap" },
  emas:      { label:"Emas",      color:"#E8A21C", icon:"🥇",  desc:"Emas (gram)" },
  forex:     { label:"Forex",     color:"#10B981", icon:"💱",  desc:"Mata uang asing — unit = jumlah valas, harga = kurs ke IDR" },
  lainnya:   { label:"Lainnya",   color:"#6B7280", icon:"📦",  desc:"Aset lainnya" },
};
